import { useEffect, useState } from 'react';
import { api, type SiteConfig } from './api';
import { storeLinksOf, type StoreLinks } from './storeLinks';

// Public settings for the landing and pricing pages: the Chip in link
// (SUPPORT_URL, M42 D105) and the published costs (M43, D113). Fetched once
// per page load and remembered, so moving between pages doesn't flicker.
let request: Promise<SiteConfig | null> | null = null;
let loaded: SiteConfig | null | undefined;

export function loadSiteConfig(): Promise<SiteConfig | null> {
  request ??= api
    .getSiteConfig()
    .then((response) => {
      loaded = response.data;
      return loaded;
    })
    .catch(() => {
      request = null;
      return null;
    });
  return request;
}

/** undefined while loading, null when it couldn't be loaded. */
export function useSiteConfig(): SiteConfig | null | undefined {
  const [config, setConfig] = useState<SiteConfig | null | undefined>(loaded);
  useEffect(() => {
    if (loaded !== undefined) return;
    let active = true;
    void loadSiteConfig().then((value) => {
      if (active) setConfig(value);
    });
    return () => {
      active = false;
    };
  }, []);
  return config;
}

export function useSupportUrl(): string | null {
  return useSiteConfig()?.supportUrl ?? null;
}

/** The app stores' links (D344): all null while loading or unset. */
export function useStoreLinks(): StoreLinks {
  return storeLinksOf(useSiteConfig());
}

/** For tests. */
export function resetSiteConfig() {
  request = null;
  loaded = undefined;
}
